import { classNameMerger } from '@breetometer/utils';
import type { ReactNode } from 'react';

export const LoadingComponent = ({
	loading,
	children,
	text,
	shape = 'default',
	max,
}: {
	children?: ReactNode;
	loading: boolean;
	text?: string;
	shape?: 'circle' | 'default';
	max?: boolean;
}) => (
	<>
		{loading ? <div className={classNameMerger('global-skeleton', shape, max && 'max')}>{text ?? 'loading...'}</div> : children}
	</>
);
